import React, { useState } from 'react'
import './Navbar.css'
import { Link } from 'react-scroll'
import MobileNav from '../mobileNav/MobileNav'

const Navbar = ({
  language
}) => {
  const [mobilenavVisible, setMobilenavVisible] = useState(false)
  const [hamburgerClass, setHamburgerClass] = useState('')
  const toggleMobilenavVisible = () => {
    setMobilenavVisible(!mobilenavVisible)
    if (hamburgerClass === '') {
      setHamburgerClass('open')
    } else {
      setHamburgerClass('')
    }
  }
  return (
    <div className="navbar">
      <div className="navlinks">
        <div className="navlink-wrapper">
          <Link to="home" spy={true} smooth={true} duration={500}>
            HOME
          </Link>
        </div>
        <div className="navlink-wrapper">
          <Link to={language === 0 ? "sobre mí" : "about"} spy={true} smooth={true} duration={500}>
            {language === 0 ? "SOBRE MI" : "ABOUT"}
          </Link>
        </div>
        <div className="navlink-wrapper">
          <Link to={language === 0 ? "experiencia" : "experience"} spy={true} smooth={true} duration={500}>
            {language === 0 ? "EXPERIENCIA" : "EXPERIENCE"}
          </Link>
        </div>
        <div className="navlink-wrapper">
          <Link to={language === 0 ? "contacto" : "contact"} spy={true} smooth={true} duration={500}>
            {language === 0 ? "CONTACTO" : "CONTACT"}
          </Link>
        </div>
      </div>
      <div className="hamburger">
        <div
          id="hamburger-icon"
          className={hamburgerClass}
          onClick={toggleMobilenavVisible}
        >
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <MobileNav
        toggleMobilenavVisible={toggleMobilenavVisible}
        mobilenavVisible={mobilenavVisible}
        language={language}
      />
    </div>
  )
}

export default Navbar
